import { render } from "./Blog.vue?vue&type=template&id=43872d58&scoped=true"
import script from "./Blog.vue?vue&type=script&lang=js"
export * from "./Blog.vue?vue&type=script&lang=js"

import "./Blog.vue?vue&type=style&index=0&id=43872d58&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-43872d58"

export default script